<template>

	<div class="user-section-heading">My Rewards</div>

	<v-divider class="my-7" />

	<MyRewardsList />

</template>



<script setup>

import MyRewardsList from "@/components/Rewards/MyRewards/MyRewards-List.vue";

</script>